import {dataHooks} from '@wix/data-hooks'

export const reserveButtonDataHooks = dataHooks<{
  button: {}
}>('reserve-button')
